import React from 'react';

import { IDocumentChecklistItem, IRequestStatusMap } from '../../declarations';
import FileUploadRow from './FileUploadRow';
import NextStepCard from './NextStepCard';

export interface ICloseDateNextStepProps {
  coeDocumentChecklistItem: IDocumentChecklistItem;
  onDocumentDownload: (id: number) => void;
  onDocumentRemove: (id: number) => void;
  onDocumentSave: (
    name: string,
    documentType: string,
    fileBase64DataUrl: string,
    requestId: number,
    checklistItemId?: number,
  ) => void;
  removeChecklistDocumentRequests: IRequestStatusMap;
  uploadChecklistDocumentRequests: IRequestStatusMap;
}

export default class CloseDateNextStep extends React.PureComponent<ICloseDateNextStepProps> {
  public render(): JSX.Element {
    return (
      <NextStepCard
        actionComponent={this.actionComponent()}
        instructions={this.instructions()}
        title="Finalize closing date change"
      />
    );
  }

  private actionComponent = () => {
    return (
      <FileUploadRow
        documentChecklistItem={this.props.coeDocumentChecklistItem}
        onDocumentDownload={this.props.onDocumentDownload}
        onDocumentRemove={this.props.onDocumentRemove}
        onDocumentSave={this.props.onDocumentSave}
        removeChecklistDocumentRequests={this.props.removeChecklistDocumentRequests}
        uploadChecklistDocumentRequests={this.props.uploadChecklistDocumentRequests}
      />
    );
  };

  private instructions = () => {
    return [
      <div key={1}>Download addendum (with new terms)</div>,
      <div key={2}>Collect buyer signature</div>,
      <div key={3}>Upload the signed addendum</div>,
    ];
  };
}
